// src/components/MenuItemListItem.tsx
import { FC, useState } from 'react';
import { Table, Group, Text, Badge, Avatar, Box } from '@mantine/core';
import { IconLeaf, IconClock } from '@tabler/icons-react';
import type { MenuItem } from '../types';
import { ViewMenuItemModal } from './ViewMenuItemModal';

interface MenuItemListItemProps {
  item: MenuItem;
  index?: number;
}

export const MenuItemListItem: FC<MenuItemListItemProps> = ({ item, index }) => {
  const [modalVisible, setModalVisible] = useState(false);

  return (
    <>
      <Table.Tr 
        style={{ 
          cursor: 'pointer',
          transition: 'background-color 0.2s ease',
        }}
        onClick={() => setModalVisible(true)}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = 'var(--mantine-color-gray-0)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = 'transparent';
        }}
      >
        {/* Image/Avatar - 40x40px */}
        <Table.Td width={50} style={{ padding: '8px' }}>
          <Avatar 
            src={item.image} 
            size={40} 
            radius="md"
            style={{ 
              objectFit: 'cover',
              border: '1px solid var(--mantine-color-gray-3)'
            }}
          >
            {!item.image && (
              <Text size="xs" fw={600} c="orange">
                {item.name.charAt(0)}
              </Text>
            )}
          </Avatar>
        </Table.Td>
        
        {/* Item Name and Description */}
        <Table.Td>
          <Box>
            <Group gap={8} align="center" wrap="nowrap">
              <Text fw={600} size="sm" lineClamp={1}>
                {item.name}
              </Text>
              {item.isVegetarian && (
                <IconLeaf size={14} color="green" />
              )}
            </Group>
            {item.description && (
              <Text size="xs" c="dimmed" lineClamp={1}>
                {item.description}
              </Text>
            )}
            {item.preparationTime && (
              <Group gap={4} mt={4}>
                <IconClock size={12} color="gray" />
                <Text size="xs" c="dimmed">
                  {item.preparationTime} min
                </Text>
              </Group>
            )}
          </Box>
        </Table.Td>
        
        {/* Veg/Non-Veg Badge */}
        <Table.Td width={90}>
          <Badge 
            size="sm" 
            variant="light" 
            color={item.isVegetarian ? 'green' : 'red'}
            style={{ textTransform: 'none' }}
          >
            {item.isVegetarian ? 'Vegetarian' : 'Non-Veg'}
          </Badge>
        </Table.Td>
        
        {/* Price */}
        <Table.Td width={100}>
          <Text fw={700} size="md" c="orange.7">
            Rs. {item.price}
          </Text>
        </Table.Td>
      </Table.Tr>

      <ViewMenuItemModal
        menuItem={item}
        opened={modalVisible}
        onClose={() => setModalVisible(false)}
      />
    </>
  );
};